import React from "react";
import {Modal, ModalHeader, ModalBody, ModalFooter} from "../../../../components/Modal";
import CustomButton from "../../../../components/CustomButton";

import "../../../../lang/i18n";
import { useTranslation } from "react-i18next";

import calendarIcon from "url:shared-assets/icons/calendar.svg";
import clockIcon from "url:shared-assets/icons/gray/clock.svg";
import { Meeting } from "../../interfaces";
import {
  dateFormatDate,
  dateFormatHourMinute,
} from "../../../../helpers/dateFunctions";

interface CancellationModalProps {
  onClose: () => void;
  isOpen: boolean;
  coachName: string;
  meeting?: Meeting;
  cancelMeeting: () => void;
}

const ConfirmCancellationModal: React.FC<CancellationModalProps> = ({
  onClose,
  isOpen,
  meeting,
  cancelMeeting,
  coachName,
}) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language
    ? i18n.language.startsWith("sv")
      ? "sv"
      : "en"
    : "en";

  if (!meeting) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHeader onClose={onClose}>
        <div className="z-title1">
          {t("confirm-cancellation-heading")}
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="flex flex-col gap-3 ">
          <p className="text-normal text-base">{coachName}</p>
          <div className="flex items-center gap-1">
            {/* Calendar Icon */}
            <img src={calendarIcon} alt="calendar icon" className="w-8 h-8" />
            {/* Date Text with Fixed Width */}
            <p>{dateFormatDate(meeting.startDate, false, lang)}</p>
          </div>
          <div className="flex items-center gap-1">
            {/* Clock Icon */}
            <img src={clockIcon} alt="clock icon" className="w-8 h-8" />
            {/* Time Text */}
            <p>{dateFormatHourMinute(meeting.startDate)}</p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <CustomButton onClick={() => cancelMeeting()}>{t("cancel-meeting")}</CustomButton>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmCancellationModal;
